export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9632.be4e87d8.jpg";